import { FC } from "react"

export const DriverMarker: FC<{ color: string }> = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    {/* Outer circle with driver color */}
    <circle cx="16" cy="16" r="15" fill={color} stroke="#fff" strokeWidth="2" />
    {/* Steering wheel / driver icon */}
    <svg x="6" y="6" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="1.5" fill="none" />
      <circle cx="12" cy="12" r="3" fill="#fff" />
      <line x1="12" y1="3" x2="12" y2="9" stroke="#fff" strokeWidth="1.5" />
      <line x1="3.7" y1="16.5" x2="9.4" y2="13.5" stroke="#fff" strokeWidth="1.5" />
      <line x1="20.3" y1="16.5" x2="14.6" y2="13.5" stroke="#fff" strokeWidth="1.5" />
    </svg>
  </svg>
)
